<template>
  <div class="view">
    <Title title="ユーザー"/>
    <UserEditMain />
  </div>
</template>

<script>
import Title from '@/components/Title.vue'
import UserEditMain from '@/components/User/EditMain'

export default {
  components: {
    Title,
    UserEditMain
  }
}
</script>
